/**
 * name:ToMenuTree  将平级菜单转化成目录树
 * author:Beginner
 * create:20200804
 * revamp:
 * email:BeginnerMind@163.com
 */
class ToMenuTree {
  constructor() {
    this.menuJson = []
    this.treeMenu = []
  }
  formate(arr) {
    if (arr) {
      // console.log(arr)
      this.menuJson = arr
      this.treeMenu = []
    }
    if (this.treeMenu && this.treeMenu.length) {
      this.findChild(this.treeMenu)
    } else {
      this.menuJson.map((item, index) => {
        item.childs = []
        item.childsId = []
        item.icon = item.code
        if (item.pid === '0') {
          this.treeMenu.push(item)
        }
      })
      if (this.treeMenu.length) {
        this.formate()
      } else {
        console.log('导航列表为空')
      }
    }
  }
  findChild(_Formated) {
    for (const iterator of _Formated) {
      this.menuJson.map((item, index) => {
        if (item.pid === iterator.id) {
          iterator.childs.push(item)
          iterator.childsId.push(item.id)
        }
      })
      if (iterator.childs.length) {
        this.findChild(iterator.childs)
      }
    }
  }
  returnData() {
    return this.treeMenu
  }
}

export default new ToMenuTree()
